import React, { useEffect, useState } from 'react';
import ConfirmDialog from '../../../../AlmeDialog/ConfirmDialog';
const AlmeLiveChatSessionTimeoutPopup = (props) => {
    const [counter, setCounter] = useState(props.timeoutInSec);
    useEffect(() => {
        let timeoutId;
        if (counter <= 0) {
            props.onTimeout();
        }
        else {
            timeoutId = window.setTimeout(() => {
                setCounter(counter - 1);
            }, 1000);
        }
        return () => { if (timeoutId)
            clearTimeout(timeoutId); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [counter]);
    return (React.createElement(ConfirmDialog, { id: "alme-live-chat-session-timeout-dialog", ariaLabelledBy: "alme-live-chat-session-timeout-dialog-title", ariaDescribedBy: "alme-live-chat-session-timeout-dialog-description", returnFocusToElement: null, isOpen: true, yesLabel: props.yesButtonText, noLabel: props.noButtonText, onYes: props.onYesClick, onNo: props.onNoClick, onClose: props.onCloseClick, title: `${props.headerText}   ${counter}`, description: `${props.bodyText}`, height: 250 }));
};
export default AlmeLiveChatSessionTimeoutPopup;
